<template>
  <div class="video">
    <div class="video-placeholder">
      <span class="video-length">{{videoLengthString}} Min</span>
      <ImageView :source="imgSrc" />
      <!-- <img class="img-fluid" :src="imgSrc" /> -->
    </div>
<!--     <div class="video-detail-container">
      <span class="badge badge-secondary">Video ID: {{videoId}}</span>
      <span class="video-length">{{videoLengthString}} Min</span>
    </div> -->
  </div>
</template>

<script>
import ImageView from '@/components/ImageView.vue';

export default {
  name: 'VideoMetaData',
  components: {
    ImageView,
  },
  computed: {
    videoLengthString() {
      const minutes = Math.floor(this.videoLength / 60);
      const seconds = this.videoLength - minutes * 60;
      let secs = Math.floor(seconds);
      if (secs < 10) {
        secs = `0${secs}`;
      }
      const returnText = `${minutes}:${secs}`;
      if (returnText.length > 5) {
        return this.transformUnit(parseFloat(returnText));
      }
      return `${minutes}:${secs}`;
    },
  },
  props: {
    videoId: {
      type: String,
      default: '',
    },
    videoLength: {
      type: Number,
      default: 0,
    },
    imgSrc: {
      type: String,
      default: 'https://via.placeholder.com/1280x720',
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';

.badge {
  display: flex;
  justify-content: center;
  align-items: center;

  &.badge-secondary {
    background-color: $gray-600;
  }
}


.img-fluid {
  width: 100%;
}

.video-placeholder {
  position: relative;

  .video-length {
    display: flex;
    justify-content: flex-end;
    margin-left: auto;
    position: absolute;
    bottom: 0;
    right: 0;
    background-color: black;
    padding: 4px 8px;
    color: white;
    font-size: $font-size-sm;
    z-index: 100;
  }
}

.video-detail-container {
  display: flex;
  flex-direction: row;
  padding: $spacer * 0.5 0;
  margin-bottom: $spacer;
}

</style>
